<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" v-bind:variant="variant" v-show="!isGame">
      <!-- <div id="nav-collapse" class="collapse mr-auto navbar-collapse" style="display: none;width: 200px;"></div> -->

      <div class="header-l mr-auto nav-menu text-left">
        <div class="d-block">
          <b-nav-form style="display: block !important;">
            <span class="btn-group nav-buttons">
              <b-button v-bind:variant="variantNavButton" v-on:click="navigateTo('/menu')" class="btn-icon" v-if="!whiteLabel" aria-label="Menu">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
                </svg>
              </b-button>
              <b-button v-bind:variant="variantNavButton" v-b-modal.modal-intro class="btn-icon" v-if="!whiteLabel" aria-label="How it works">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                  <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
                </svg>
              </b-button>

              <!-- <span class="btn-group"> -->
                <b-button v-bind:variant="variantNavButton" v-on:click="doUpload()" v-if="$route.path === '/' || $route.path === '/tang' || $route.path === '/dob' || $route.path === '/preme' || $route.path === '/zora'">
                  UPLOAD 
                  <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-upload" viewBox="0 0 16 16">
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                    <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"/>
                  </svg> -->
                </b-button>
                <b-button v-bind:variant="variantNavButton" v-on:click="doUploadAvatar" v-if="!canBuy && $route.path === '/' && connectAccountEnsAvatar != ''" class="btn-icon">
                  <img v-bind:src="connectAccountEnsAvatar" class="ensAvatar" alt="Upload my avatar">
                </b-button>
              <!-- </span> -->
              
            </span>
          </b-nav-form>
        </div>
      </div>

      <div class="mr-0 p-0 header-m">
        <span class="honk-text mbh-title" v-on:click="navigateTo('/')" v-if="!whiteLabel">Million Bit Homepage</span>
        <p class="subtitle dm-sans-text" v-if="!canBuy">
          1,000,000 pixels 
          • <span v-if="ethTokenToggle"><span v-text="ethPerPixel"></span> <span>ETH</span></span>
          <span v-if="!ethTokenToggle"><span v-text="tokenPerPixel"></span> <span v-text="symbol"></span></span>
           per pixel 
          • Own a bit of onchain history!
        </p>

        <div class="d-block text-center mb-3" v-if="canBuy">
          <b-nav-form class="text-center">
            <span class="btn-group" v-if="canToggleEthToken">
              <b-button v-bind:variant="variantNavButton" v-on:click="doToggleEthToken(true)" v-bind:class="{'btn-outline-lighter': !ethTokenToggle}">
                <span>ETH</span>
              </b-button>
              <b-button v-bind:variant="variantNavButton" v-on:click="doToggleEthToken(false)" v-bind:class="{'btn-outline-lighter': ethTokenToggle}">
                <span v-text="symbol"></span>
              </b-button>
            </span>
            <button type="button" class="btn" disabled style="color: white;">
              <span v-if="ethTokenToggle"><span v-text="ethAmtFormatted"></span> ETH</span>
              <span v-if="!ethTokenToggle"><span v-text="tokenAmt"></span> <span v-text="symbol"></span></span>
            </button>

            <b-form-input size="md" class="mr-md-2" placeholder="http link address" type="url" id="link-url" v-bind:value="formInputUrl" @keydown.enter.prevent="blurInput" ref="formInputValueUrl"></b-form-input>
            
            <b-button variant="warning" v-on:click="doBuy" v-if="canSend" v-bind:disabled="buyLoading">
              <span><div class="loader" v-if="buyLoading"></div> <span v-if="canMint">MINT</span><span v-else>SEND</span></span>
            </b-button>
            <!-- <b-button v-bind:variant="'sm'" v-on:click="cancelBuy">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
              </svg>
            </b-button> -->
          </b-nav-form>
        </div>
      </div>
  
      <div class="header-r ml-auto connect-menu text-right">

        <b-button id="connect-wallet" v-on:click="connectWallet()" v-if="!connectAccountAddress" class="btn btn-primary" v-bind:variant="'connect'">
          Connect Wallet
        </b-button>

        <span class="btn-group" v-if="connectAccountAddress">
          <b-button v-bind:variant="variantNavButton" v-on:click="navigateTo('/plots')">
            <span v-if="connectAccountEnsAvatar"><img v-bind:src="connectAccountEnsAvatar" style="border-radius: 50%;" alt="" /></span>
            <span v-if="connectAccountEnsName" v-text="connectAccountEnsNameTrunc"></span>
            <span v-if="!connectAccountEnsName" v-text="connectAccountAddressTrunc"></span>
          </b-button>
          <b-button class="disconnect" v-bind:variant="variantNavButton" v-on:click="doDisconnect()" aria-label="Disconnect wallet">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-right" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"/>
              <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
            </svg>
          </b-button>
        </span>
        <div v-if="connectAccountAddress && !isBaseChain(connectAccountChainId)" class="my-2">
          <b-button v-bind:variant="'warning'" v-on:click="switchToBaseChain()">Switch to Base</b-button>
        </div>
      </div>
      <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle> -->
    </b-navbar>

    <div class="rewards-header" v-if="rewardsMsg">
      {{ rewardsMsg }}
    </div>
    <div class="promo-header" v-if="showPromo">
      {{ promoMsg }}
    </div>

    <router-view ref="routerViewRef"></router-view>

    <div id="countdown" class="mb-5" v-show="!isGame && !isZora">
      <p class="text-bold" v-if="!whiteLabel">Pixel price goes up with each minted plot!</p>
      <p class="text-bold" v-if="whiteLabel">Powered by the <a href="https://millionbithomepage.com" target="_blank">Million Bit Homepage</a></p>
      <!-- <p class="text-center">PLOTS MINTED
        <span v-text="totalPlots"></span>
      </p> -->
      <!-- <ul>
        <li><span id="days"></span>days</li>
        <li><span id="hours"></span>Hours</li>
        <li><span id="minutes"></span>Minutes</li>
        <li><span id="seconds"></span>Seconds</li>
      </ul> -->
    </div>

    <b-modal id="modal-connect" title="Connect your wallet" hide-footer size="sm">
      <b-button id="create-wallet" v-on:click="createWallet()" v-if="!connectAccountAddress" class="btn btn-block btn-primary mb-4" v-bind:variant="'connect'">
        <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI4IDU2YzE1LjQ2NCAwIDI4LTEyLjUzNiAyOC0yOFM0My40NjQgMCAyOCAwIDAgMTIuNTM2IDAgMjhzMTIuNTM2IDI4IDI4IDI4WiIgZmlsbD0iIzFCNTNFNCIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAyOGMwIDExLjU5OCA5LjQwMiAyMSAyMSAyMXMyMS05LjQwMiAyMS0yMVMzOS41OTggNyAyOCA3IDcgMTYuNDAyIDcgMjhabTE3LjIzNC02Ljc2NmEzIDMgMCAwIDAtMyAzdjcuNTMzYTMgMyAwIDAgMCAzIDNoNy41MzNhMyAzIDAgMCAwIDMtM3YtNy41MzNhMyAzIDAgMCAwLTMtM2gtNy41MzNaIiBmaWxsPSIjZmZmIi8+PC9zdmc+">
         Create Wallet
      </b-button>
      <a v-bind:href="deepLinkMetamask" target="_blank" v-if="!connectAccountAddress && providers.length === 0" class="btn btn-block btn-primary mb-4"><img src="data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjMzIiB2aWV3Qm94PSIwIDAgMzUgMzMiIHdpZHRoPSIzNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iLjI1Ij48cGF0aCBkPSJtMzIuOTU4MiAxLTEzLjEzNDEgOS43MTgzIDIuNDQyNC01LjcyNzMxeiIgZmlsbD0iI2UxNzcyNiIgc3Ryb2tlPSIjZTE3NzI2Ii8+PGcgZmlsbD0iI2UyNzYyNSIgc3Ryb2tlPSIjZTI3NjI1Ij48cGF0aCBkPSJtMi42NjI5NiAxIDEzLjAxNzE0IDkuODA5LTIuMzI1NC01LjgxODAyeiIvPjxwYXRoIGQ9Im0yOC4yMjk1IDIzLjUzMzUtMy40OTQ3IDUuMzM4NiA3LjQ4MjkgMi4wNjAzIDIuMTQzNi03LjI4MjN6Ii8+PHBhdGggZD0ibTEuMjcyODEgMjMuNjUwMSAyLjEzMDU1IDcuMjgyMyA3LjQ2OTk0LTIuMDYwMy0zLjQ4MTY2LTUuMzM4NnoiLz48cGF0aCBkPSJtMTAuNDcwNiAxNC41MTQ5LTIuMDc4NiAzLjEzNTggNy40MDUuMzM2OS0uMjQ2OS03Ljk2OXoiLz48cGF0aCBkPSJtMjUuMTUwNSAxNC41MTQ5LTUuMTU3NS00LjU4NzA0LS4xNjg4IDguMDU5NzQgNy40MDQ5LS4zMzY5eiIvPjxwYXRoIGQ9Im0xMC44NzMzIDI4Ljg3MjEgNC40ODE5LTIuMTYzOS0zLjg1ODMtMy4wMDYyeiIvPjxwYXRoIGQ9Im0yMC4yNjU5IDI2LjcwODIgNC40Njg5IDIuMTYzOS0uNjEwNS01LjE3MDF6Ii8+PC9nPjxwYXRoIGQ9Im0yNC43MzQ4IDI4Ljg3MjEtNC40NjktMi4xNjM5LjM2MzggMi45MDI1LS4wMzkgMS4yMzF6IiBmaWxsPSIjZDViZmIyIiBzdHJva2U9IiNkNWJmYjIiLz48cGF0aCBkPSJtMTAuODczMiAyOC44NzIxIDQuMTU3MiAxLjk2OTYtLjAyNi0xLjIzMS4zNTA4LTIuOTAyNXoiIGZpbGw9IiNkNWJmYjIiIHN0cm9rZT0iI2Q1YmZiMiIvPjxwYXRoIGQ9Im0xNS4xMDg0IDIxLjc4NDItMy43MTU1LTEuMDg4NCAyLjYyNDMtMS4yMDUxeiIgZmlsbD0iIzIzMzQ0NyIgc3Ryb2tlPSIjMjMzNDQ3Ii8+PHBhdGggZD0ibTIwLjUxMjYgMjEuNzg0MiAxLjA5MTMtMi4yOTM1IDIuNjM3MiAxLjIwNTF6IiBmaWxsPSIjMjMzNDQ3IiBzdHJva2U9IiMyMzM0NDciLz48cGF0aCBkPSJtMTAuODczMyAyOC44NzIxLjY0OTUtNS4zMzg2LTQuMTMxMTcuMTE2N3oiIGZpbGw9IiNjYzYyMjgiIHN0cm9rZT0iI2NjNjIyOCIvPjxwYXRoIGQ9Im0yNC4wOTgyIDIzLjUzMzUuNjM2NiA1LjMzODYgMy40OTQ2LTUuMjIxOXoiIGZpbGw9IiNjYzYyMjgiIHN0cm9rZT0iI2NjNjIyOCIvPjxwYXRoIGQ9Im0yNy4yMjkxIDE3LjY1MDctNy40MDUuMzM2OS42ODg1IDMuNzk2NiAxLjA5MTMtMi4yOTM1IDIuNjM3MiAxLjIwNTF6IiBmaWxsPSIjY2M2MjI4IiBzdHJva2U9IiNjYzYyMjgiLz48cGF0aCBkPSJtMTEuMzkyOSAyMC42OTU4IDIuNjI0Mi0xLjIwNTEgMS4wOTEzIDIuMjkzNS42ODg1LTMuNzk2Ni03LjQwNDk1LS4zMzY5eiIgZmlsbD0iI2NjNjIyOCIgc3Ryb2tlPSIjY2M2MjI4Ii8+PHBhdGggZD0ibTguMzkyIDE3LjY1MDcgMy4xMDQ5IDYuMDUxMy0uMTAzOS0zLjAwNjJ6IiBmaWxsPSIjZTI3NTI1IiBzdHJva2U9IiNlMjc1MjUiLz48cGF0aCBkPSJtMjQuMjQxMiAyMC42OTU4LS4xMTY5IDMuMDA2MiAzLjEwNDktNi4wNTEzeiIgZmlsbD0iI2UyNzUyNSIgc3Ryb2tlPSIjZTI3NTI1Ii8+PHBhdGggZD0ibTE1Ljc5NyAxNy45ODc2LS42ODg2IDMuNzk2Ny44NzA0IDQuNDgzMy4xOTQ5LTUuOTA4N3oiIGZpbGw9IiNlMjc1MjUiIHN0cm9rZT0iI2UyNzUyNSIvPjxwYXRoIGQ9Im0xOS44MjQyIDE3Ljk4NzYtLjM2MzggMi4zNTg0LjE4MTkgNS45MjE2Ljg3MDQtNC40ODMzeiIgZmlsbD0iI2UyNzUyNSIgc3Ryb2tlPSIjZTI3NTI1Ii8+PHBhdGggZD0ibTIwLjUxMjcgMjEuNzg0Mi0uODcwNCA0LjQ4MzQuNjIzNi40NDA2IDMuODU4NC0zLjAwNjIuMTE2OS0zLjAwNjJ6IiBmaWxsPSIjZjU4NDFmIiBzdHJva2U9IiNmNTg0MWYiLz48cGF0aCBkPSJtMTEuMzkyOSAyMC42OTU4LjEwNCAzLjAwNjIgMy44NTgzIDMuMDA2Mi42MjM2LS40NDA2LS44NzA0LTQuNDgzNHoiIGZpbGw9IiNmNTg0MWYiIHN0cm9rZT0iI2Y1ODQxZiIvPjxwYXRoIGQ9Im0yMC41OTA2IDMwLjg0MTcuMDM5LTEuMjMxLS4zMzc4LS4yODUxaC00Ljk2MjZsLS4zMjQ4LjI4NTEuMDI2IDEuMjMxLTQuMTU3Mi0xLjk2OTYgMS40NTUxIDEuMTkyMSAyLjk0ODkgMi4wMzQ0aDUuMDUzNmwyLjk2Mi0yLjAzNDQgMS40NDItMS4xOTIxeiIgZmlsbD0iI2MwYWM5ZCIgc3Ryb2tlPSIjYzBhYzlkIi8+PHBhdGggZD0ibTIwLjI2NTkgMjYuNzA4Mi0uNjIzNi0uNDQwNmgtMy42NjM1bC0uNjIzNi40NDA2LS4zNTA4IDIuOTAyNS4zMjQ4LS4yODUxaDQuOTYyNmwuMzM3OC4yODUxeiIgZmlsbD0iIzE2MTYxNiIgc3Ryb2tlPSIjMTYxNjE2Ii8+PHBhdGggZD0ibTMzLjUxNjggMTEuMzUzMiAxLjEwNDMtNS4zNjQ0Ny0xLjY2MjktNC45ODg3My0xMi42OTIzIDkuMzk0NCA0Ljg4NDYgNC4xMjA1IDYuODk4MyAyLjAwODUgMS41Mi0xLjc3NTItLjY2MjYtLjQ3OTUgMS4wNTIzLS45NTg4LS44MDU0LS42MjIgMS4wNTIzLS44MDM0eiIgZmlsbD0iIzc2M2UxYSIgc3Ryb2tlPSIjNzYzZTFhIi8+PHBhdGggZD0ibTEgNS45ODg3MyAxLjExNzI0IDUuMzY0NDctLjcxNDUxLjUzMTMgMS4wNjUyNy44MDM0LS44MDU0NS42MjIgMS4wNTIyOC45NTg4LS42NjI1NS40Nzk1IDEuNTE5OTcgMS43NzUyIDYuODk4MzUtMi4wMDg1IDQuODg0Ni00LjEyMDUtMTIuNjkyMzMtOS4zOTQ0eiIgZmlsbD0iIzc2M2UxYSIgc3Ryb2tlPSIjNzYzZTFhIi8+PHBhdGggZD0ibTMyLjA0ODkgMTYuNTIzNC02Ljg5ODMtMi4wMDg1IDIuMDc4NiAzLjEzNTgtMy4xMDQ5IDYuMDUxMyA0LjEwNTItLjA1MTloNi4xMzE4eiIgZmlsbD0iI2Y1ODQxZiIgc3Ryb2tlPSIjZjU4NDFmIi8+PHBhdGggZD0ibTEwLjQ3MDUgMTQuNTE0OS02Ljg5ODI4IDIuMDA4NS0yLjI5OTQ0IDcuMTI2N2g2LjExODgzbDQuMTA1MTkuMDUxOS0zLjEwNDg3LTYuMDUxM3oiIGZpbGw9IiNmNTg0MWYiIHN0cm9rZT0iI2Y1ODQxZiIvPjxwYXRoIGQ9Im0xOS44MjQxIDE3Ljk4NzYuNDQxNy03LjU5MzIgMi4wMDA3LTUuNDAzNGgtOC45MTE5bDIuMDAwNiA1LjQwMzQuNDQxNyA3LjU5MzIuMTY4OSAyLjM4NDIuMDEzIDUuODk1OGgzLjY2MzVsLjAxMy01Ljg5NTh6IiBmaWxsPSIjZjU4NDFmIiBzdHJva2U9IiNmNTg0MWYiLz48L2c+PC9zdmc+"> Metamask</a>
      <a v-bind:href="deepLinkCoinbase" target="_blank" v-if="!connectAccountAddress && providers.length === 0" class="btn btn-block btn-primary mb-4"><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI4IDU2YzE1LjQ2NCAwIDI4LTEyLjUzNiAyOC0yOFM0My40NjQgMCAyOCAwIDAgMTIuNTM2IDAgMjhzMTIuNTM2IDI4IDI4IDI4WiIgZmlsbD0iIzFCNTNFNCIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAyOGMwIDExLjU5OCA5LjQwMiAyMSAyMSAyMXMyMS05LjQwMiAyMS0yMVMzOS41OTggNyAyOCA3IDcgMTYuNDAyIDcgMjhabTE3LjIzNC02Ljc2NmEzIDMgMCAwIDAtMyAzdjcuNTMzYTMgMyAwIDAgMCAzIDNoNy41MzNhMyAzIDAgMCAwIDMtM3YtNy41MzNhMyAzIDAgMCAwLTMtM2gtNy41MzNaIiBmaWxsPSIjZmZmIi8+PC9zdmc+"> Coinbase</a>
      <span v-for="provider in providers">
        <b-button v-if="!connectAccountAddress" class="btn-block btn-primary mb-4" v-bind:variant="'connect'" v-on:click="doConnect(provider)" v-bind:disabled="isConnecting">
          <img v-bind:src="provider.info.icon" /> {{ provider.info.name }}
        </b-button>
      </span>
    </b-modal>


    <b-modal id="modal-token" title="Own a bit of blockchain history!" hide-footer size="lg">
      <h2 v-text="symbol"></h2>
      <div class="row">
        <div class="col-12">
          <a href="#" class="btn btn-block btn-outline-dark btn-lg"><svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path></svg>
          <span v-text="contractAddress" v-on:click="doCopyToClipboard(contractAddress)"></span></a>
          <br />
          <a href="#" class="btn btn-outline-dark btn-block" v-on:click="watchToken()">Watch token in wallet</a>
          <br />
        </div>
        <br /><br />
        <br />
      </div>

    <h2>Launch status</h2>
    <p>Coming soon.. join us on telegram for updates on the upcoming launch!</p>

      <!-- <div class="row">
        <div class="col-6">
          <a href="#" class="btn btn-block btn-warning btn-lg">🔁 SWAP</a>
        </div>
        <div class="col-6">
          <a href="#" class="btn btn-block btn-warning btn-lg">📈 CHART</a>
        </div>
      </div>
      <hr />
      <h2>Tokenomics</h2>
      <p>90% LP</p>
      <p>10% TREASURY</p>

      <h2>Utility</h2>
      <p>Used to get a piece of the Million Bit Hompeage.  Put pixels onchain to support your favorite project.</p> -->
    </b-modal>

    <b-modal id="modal-alert" hide-header hide-footer size="lg">
      <h3 v-text="alertMsg" class="text-center"></h3>
      <div v-if="alertSwapOpts && alertSwapOpts.amountNeeded">
        <h5 class="text-center m-2"><span v-text="alertSwapOpts.amountNeededFormatted"></span> more <span v-text="symbol"></span> needed to mint your plot.</h5>
        <br />
        <div class="btn-group btn-block">
          <button class="btn btn-block btn-primary btn-lg" v-on:click="doSwap(alertSwapOpts.amountNeeded)">
            SWAP
          </button>
          <a href="https://app.uniswap.org/swap?outputCurrency=0x5ca35371263CA25e0BC8005fB44e0c37D0a0BdfD&chain=base" target="_blank" class="external-link m-0 btn btn-block btn-primary btn-lg" style="max-width: 100px;">
            <img src="/static/external-link.svg" alt="Swap on Uniswap" style="max-height: 20px;" />
          </a>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-swap" hide-header hide-footer size="lg">
      <h1>Swap</h1>
      <h3 v-text="alertMsg" class="text-center"></h3>
      <div v-if="alertSwapOpts && alertSwapOpts.amountNeeded">
        <h5 class="text-center m-2"><span v-text="alertSwapOpts.amountNeededFormatted"></span> more <span v-text="symbol"></span> needed to mint your plot.</h5>
        <br />
        eth
        million zora post
        <br />
        <div class="btn-group">
          <button class="btn btn-block btn-primary btn-lg" v-on:click="doSwap(alertSwapOpts.amountNeeded)">
            SWAP
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-intro" title="👋 Welcome to the Million Bit Homepage!" hide-footer size="lg">
      <p>
        Add your image to the homepage and be forever immortalized on the blockchain!
      </p>

      <h3 class="my-4">💰 What you get</h3>
      <p class="text-left">
        <b>NFT of your plot!</b>
        You own your plot forever. List it on 
        <!-- <a href="https://opensea.io/collection/million-bit-homepage" target="_blank">OpenSea</a> & -->
        <a href="https://magiceden.us/collections/base/0x25b9afe64bb3593ec7e9dc7ef386a9b04c53f96e" target="_blank">Magic Eden</a> and <a @click.prevent="navigateTo('/plots')" href="#">update your plot</a>.
      </p>
      <p class="text-left">
        <b>Earn rewards for your NFTs.</b>
        Get rewarded for the pixels you've minted.
        <!-- <a href="https://opensea.io/collection/million-bit-homepage" target="_blank">OpenSea</a> & -->
        <a @click.prevent="navigateTo('/plots')" href="#">Claim now</a>.
      </p>
      <p class="text-left">
        <b>Join the MBH community.</b>
        <a @click.prevent="navigateTo('/spaces')" href="#">Twitter X spaces</a> and access to our exclusive Twitter X group.
      </p>
      <p class="text-left">
        <b>Included in marketing and games.</b>
        Instantly included in our games <a @click.prevent="navigateTo('/break')" href="#">Break</a> & <a @click.prevent="navigateTo('/drop')" href="#">Drop</a>.
        <!-- , and marketing of the homepage. -->
      </p>
      <hr />

      <h3 class="my-4">👩‍🏫 How it works</h3>
      <p class="text-left">
        <b class="pr-2">Step 1</b> 
        Click on the UPLOAD button.
      </p>
      <p class="text-left">
        <b class="pr-2">Step 2</b> 
        Move and resize your image.
      </p>
      <p class="text-left">
        <b class="pr-2">Step 3</b> 
        Click the MINT button.
      </p>
      <p class="text-left">
        <b class="pr-2">Step 4</b> 
        Check back in a minute to see your addition!
      </p>

      <hr />

      <h3 class="my-4">📽️ See it in action</h3>
      <p>
        Watch an example of how easy it is to claim your plot on the homepage.
      </p>
      <!-- <a href="https://x.com/BitHomepage/status/1809991768177246675" target="_blank" class="btn btn-primary btn-block">Watch video</a> -->
      <a href="#" class="btn btn-primary btn-block" @click.prevent="navigateTo('demo')">Watch video</a>
    </b-modal>

    <b-modal id="modal-success" title="You're a part of blockchain history!" hide-footer size="lg">
      <p>
        Thank you for being a part of blockchain history 💙
        <br /><a v-if="trxHashSuccess" v-bind:href="'https://basescan.org/tx/'+trxHashSuccess" target="_blank">View transaction</a>
        <br /><br />
        Please allow a few minutes to process your pixels from the blockchain and be added to the <span v-if="!whiteLabel && !isZora">homepage</span><span v-if="whiteLabel || isZora">page</span>.
        <br /><br />
        Make sure to join our community on <a v-bind:href="telegram" target="_blank">Telegram</a> and <a v-bind:href="twitter" target="_blank">Twitter</a>.
        <br /><br />
        <span v-if="!whiteLabel && !isZora">Share the Million Bit Homepage with your friends!
        <br /><br />
        <a href="#" class="btn btn-block btn-outline-dark btn-lg">
          <span v-text="shareUrl" v-on:click="doCopyToClipboard(shareUrl)"></span>
        </a>
        </span>
      </p>
      <hr />
      <a v-bind:href="xPostSuccess" target="_blank" class="btn btn-block btn-lg btn-primary">Share on X</a><br />
    </b-modal>
    
    <b-modal id="modal-invite-friends" title="Invite Friends" hide-footer size="lg">
      <h1>Refer your friends!</h1>
      <p>
        Share the Million Bit Homepage with your friends!
      </p>
      <span v-if="!connectAccountAddress">
        <b>Connect your wallet to get your referral link</b>
      </span>
      <span v-if="connectAccountAddress">
        <b>Share invite link</b>
        <a href="#" class="btn btn-block btn-outline-dark btn-lg">
          <span v-text="shareUrl" v-on:click="doCopyToClipboard(shareUrl)"></span>
        </a>
        <hr />
        <a v-bind:href="xPostInvite" target="_blank" class="btn btn-block btn-lg btn-primary">Share on X</a><br />
      </span>
    </b-modal>

    <div id="fine-uploader-manual-trigger" style="display:none;"></div> 

    <div id="mobile-controls" v-if="isMobileOrTouch && canBuy">
      <p class="mc-hint" v-if="!canSend">⬆️ Move your image to an empty spot</p>
      <div id="control-down" role="button" aria-label="Move down"
          @click="btnPress"
          @touchstart="handleTouchStart($event, 'down')"
          @touchend="handleTouchEnd"
          @touchcancel="handleTouchCancel">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"/>
        </svg>
      </div>
      <div id="control-left" role="button" aria-label="Move left"
          @click="btnPress"
          @touchstart="handleTouchStart($event, 'left')"
          @touchend="handleTouchEnd"
          @touchcancel="handleTouchCancel">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
        </svg>
      </div>
      <div id="control-right" role="button" aria-label="Move right"
          @click="btnPress"
          @touchstart="handleTouchStart($event, 'right')"
          @touchend="handleTouchEnd"
          @touchcancel="handleTouchCancel">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
        </svg>
      </div>
      <div id="control-up" role="button" aria-label="Move up"
          @click="btnPress"
          @touchstart="handleTouchStart($event, 'up')"
          @touchend="handleTouchEnd"
          @touchcancel="handleTouchCancel">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"/>
        </svg>
      </div>
      <div id="control-smaller" role="button" aria-label="Make smaller" v-on:click="resizeSpot('smaller')">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-zoom-out" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"/>
          <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"/>
          <path fill-rule="evenodd" d="M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"/>
        </svg>
      </div>
      <div id="control-bigger" role="button" aria-label="Make bigger" v-on:click="resizeSpot('bigger')">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-zoom-in" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"/>
          <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"/>
          <path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5"/>
        </svg>
      </div>
    </div> 
    
    <div class="bg-white mbh-footer" v-show="!isGame">
      <b-navbar variant="white">
        <b-navbar-brand href="#">
          <span class="honk-text">MBH</span>
        </b-navbar-brand>
        <b-navbar-nav>
          <b-nav-item v-bind:href="email" target="_blank" variant="link" v-bind:link-attrs="{ 'aria-label': 'Email' }">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
              <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z"/>
            </svg>
          </b-nav-item>
          <b-nav-item v-bind:href="telegram" target="_blank" variant="link" v-bind:link-attrs="{ 'aria-label': 'Telegram' }">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telegram" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"/>
            </svg>
          </b-nav-item>
          <!-- <b-nav-item v-bind:href="discord" target="_blank" variant="link">Discord</b-nav-item> -->
          <b-nav-item v-bind:href="twitter" target="_blank" variant="link" v-bind:link-attrs="{ 'aria-label': 'X (Twitter)' }">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
              <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
            </svg>
          </b-nav-item>
          <b-nav-item v-if="false" variant="link" href="https://www.complainonchain.xyz/millionbithomepage" target="_blank" class="send-feedback"><img src="/static/keren.webp" /> Feedback</b-nav-item>
          <b-nav-item variant="link" @click.prevent="showInviteFriends()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-megaphone-fill" viewBox="0 0 16 16">
            <path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25 25 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009l.496.008a64 64 0 0 1 1.51.048m1.39 1.081q.428.032.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a66 66 0 0 1 1.692.064q.491.026.966.06"/>
          </svg>
          Invite friends
        </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <!-- <b-button disabled variant="link">Made with 💙</b-button> -->
          <b-nav-item variant="link" @click.prevent="navigateTo('/agents')">Agents</b-nav-item>
          <b-nav-item variant="link" @click.prevent="navigateTo('/terms')">Terms</b-nav-item>
          <b-nav-item variant="link" @click.prevent="navigateTo('/privacy')">Privacy</b-nav-item>
        </b-navbar-nav>
      </b-navbar>
      <b-button disabled variant="link" id="copyright">© 2025. All rights reserved. Not responsible for the content of external sites or images featured which are © of their respective owners.</b-button>
    </div>

    <div class="confetti-wrapper">
      <div class="js-container c-container"></div>
    </div>
    <div id="toast"></div>
    <div v-if="!watchedDemo && !whiteLabel && !isZora" id="pfp-vid-container" @click.prevent="showDemoVideo">
      <div id="pfp-vid">
        <video v-if="pfpVidSrc" v-bind:src="pfpVidSrc" autoplay loop muted playsinline></video>
      </div>
    </div>
  </div>
</template>

<script>

/*global ethers*/
/*global ethereum*/
/*global qq*/
/*global interact*/
/*global pako*/
/*global _*/
import { Buffer } from 'buffer/';
window.Buffer = Buffer;

import Vue from 'vue'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

import utils from './utils';
import config from './config';
import { log, trackEvent, DO_LOG, LOCAL_STORAGE_KEY_REFERRAL } from './wallet/shared';
import walletMixin from './wallet/walletMixin';
import mintMixin from './wallet/mintMixin';

const DEMO_MODE = process.env.DEMO_MODE || false;
const DEMO_ADDRESS = process.env.DEMO_ADDRESS || false;
const PUSH_SUB_URL = 'https://nnwj3qjluewoavvztzguep5yse0dgbet.lambda-url.us-west-2.on.aws/';
const TOKEN_PIXEL_PRICE = 1;
const ETH_PIXEL_PRICE = DEMO_ADDRESS ? 0.000085 : 0.000085; // 0.000085 // $1 USD at 5/29/2024
const PIXEL_PER_SQUARE = 16;
const MAX_IMAGE_SIZE = PIXEL_PER_SQUARE * 4;
const applicationServerPublicKey = 'BESOSUO9VPh2EnimIVXt9MjactiD21wbBivbfB4JZr5UWtVN8dQGUOg0uFzB9uWFdLPGfYFkCCDq3pv6XzNIGrQ';
const DID_PROMPT_NOTIFICATIONS = 'DID_PROMPT_NOTIFICATIONS';
const LOCAL_STORAGE_NOTIFICATION_SUB_ENDPOINT = 'NOTIFICATION_SUB_ENDPOINT';
const LOCAL_STORAGE_KEY_DEMO_VID = 'DEMO_VID';

function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function getPriceForPosition(img_offset_x, img_offset_y, canvasWidth, canvasHeight, disallowExistingPixels) {
  let tokenCost = 0;
  // log('getPriceForPosition', img_offset_x, img_offset_y, canvasWidth, canvasHeight)
  window.segmentPrices = [];

  let coversExistingPixels = false;
  const pixelsPerSegment = 16 * 16;
  
  _.times(canvasHeight/16, function(h){
    let cols = [];
    _.times(canvasWidth/16, function(w){
      // Find if there is a link for this plot
      const x1 = (img_offset_x)+(w*16);
      const y1 = (img_offset_y)+(h*16);
      
      // log(`getPriceForPosition`, x1, y1, x1 + 16, y1 + 16);
      let linkDoc = _.find(window.linkMap, { 'c': `${x1},${y1},${x1 + 16},${y1 + 16}` });
      if (linkDoc) {
        log('linkDoc', linkDoc);
        if (linkDoc.u) {
          coversExistingPixels = true;
        }
      }
      
      let sectionPriceInWei = pixelsPerSegment;
      tokenCost = tokenCost + sectionPriceInWei;
      
      cols.push(tokenCost);
    });
    window.segmentPrices.push(cols)
  });

  if (disallowExistingPixels && coversExistingPixels) {
    return false;
  }
  
  // log('window.segmentPrices', window.segmentPrices)
  return tokenCost;
}

async function getImageFromBlob(blob) {
  return new Promise(function(resolve, reject) {
    const img = new Image();
    img.onload = function() {
      resolve(img);
    };
    img.onerror = function(e) {
      console.error("Error loading image from blob:", e);
      reject(e);
    };
    img.src = URL.createObjectURL(blob);
  });
}

async function getScaledImageContext(width, height, uploadedBlob) {
  return new Promise(function(resolve, reject) {
    // Detached canvas: this runs on every resize/drag, so don't add it to the page.
    var newCanvas = document.createElement('canvas');
    newCanvas.width = width;
    newCanvas.height = height;
    var destCtx = newCanvas.getContext("2d");

    getImageFromBlob(uploadedBlob).then((origImg) => {
        destCtx.imageSmoothingEnabled = true;
        destCtx.imageSmoothingQuality = 'high';
        destCtx.clearRect(0, 0, width, height);
        destCtx.drawImage(origImg, 0, 0, width, height);
        resolve(destCtx);
    }).catch((e) => {
        console.error("Error getting image from blob:", e);
        reject(e);
    });
  });
}

function fetchImage(url) {
  return fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const fileName = url.substring(url.lastIndexOf('/') + 1);
      return new File([blob], fileName, { type: blob.type });
    });
}

function setImageOffset(x, y) {
  window.img_offset_x = x;
  window.img_offset_y = y;
}

async function setImageSize(self, width, height, x, y) {
  log('setImageSize', width, height, x, y);

  // Re sample reference image
  var uploadedImgCanvas = document.getElementById("uploadedImg");
  uploadedImgCanvas.style.display = 'block';
  uploadedImgCanvas.width = width;
  uploadedImgCanvas.height = height;
  uploadedImgCanvas.style.width = width+'px';
  uploadedImgCanvas.style.height = height+'px';
  var uploadedImgCtx = uploadedImgCanvas.getContext("2d");
  uploadedImgCtx.imageSmoothingEnabled = true;
  uploadedImgCtx.imageSmoothingQuality = 'high';
  const origImg = await getImageFromBlob(window.uploadedBlob);
  uploadedImgCtx.clearRect(0, 0, width, height);
  uploadedImgCtx.drawImage(origImg, 0, 0, width, height);

  // Set pixel data scaled
  var destCtx = await getScaledImageContext(width, height, window.uploadedBlob);
  let d = destCtx.getImageData(0, 0, width, height).data;
  utils.replaceTransparent(d);
  window.myImageData = d;

  window.img_width = width;
  window.img_height = height;

  if (x !== undefined && y !== undefined) {
    setImageOffset(x, y);
  }

  // Re validate image location
  self.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
}

function initUploader(self) {
  log('initUploader')
  setImageOffset(0, 0);
  
  if(window.manualUploader) {
    utils.clearDraggableImage();
    window.manualUploader.reset();
    delete window.manualUploader;
  }
  
  if(window.interactable) {
    window.interactable.unset();
    delete window.interactable;
  }
  
  if(self.loader) {
    self.loader.hide();
  }
  
  function resizeImageMax(canvas, img) {
    // Resize if too large
    let maxSize = MAX_IMAGE_SIZE;
    let width = canvas.width;
    let height = canvas.height;
    if (width > height) {
      if (width > maxSize) {
          height *= maxSize / width;
          width = maxSize;
        }
    } else {
      if (height > maxSize) {
        width *= maxSize / height;
        height = maxSize;
      }
    }

    // Scale to PIXEL_PER_SQUARE 
    if(width % PIXEL_PER_SQUARE !== 0) {
      width = width - (width % PIXEL_PER_SQUARE);
    }
    if(height % PIXEL_PER_SQUARE !== 0) {
      height = height - (height % PIXEL_PER_SQUARE);
    }
    return { canvasWidth: width, canvasHeight: height }
  }

  window.uploadedImgData = null;

  window.manualUploader = new qq.FineUploader({
      element: document.getElementById('fine-uploader-manual-trigger'),
      template: 'qq-template-manual-trigger',
      callbacks: {
        onStatusChange: function(id, old, newStatus) {
          log("onStatusChange", arguments);
          if(newStatus === 'submitting') {
            log('submitting');
            self.loader = self.$loading.show({
              // Optional parameters
              // container: this.fullPage ? null : this.$refs.formContainer,
              // canCancel: true,
              // onCancel: this.onCancel,
            });
          } else if (newStatus === 'submitted') {
            log('submitted');
          } else if (newStatus === 'rejected') {
            this.reset();
            self.loader.hide();
            self.showAlert('The selected image is too large.')
          }
        },
        // onSubmitted: function(id) {
        //   log("onSubmitted", self)
        // },
        // onSubmit: function(id) {
        //   log("onSubmit", self)
        // },
        // onCancel: function(id) {
        //   log("CANCELED")
        // },
        // onProgress: function(id) {
        //   log("onProgress")
        // },
        // onValidate: function(id) {
        //   log("onValidate")
        // },
        // onError: function(id) {
        //   log("onError", arguments)
        // },
      },
      thumbnails: {
          // placeholders: {
          //     waitingPath: '/source/placeholders/waiting-generic.png',
          //     notAvailablePath: '/source/placeholders/not_available-generic.png'
          // },
        customResizer: async function(resizeInfo) {
          return new Promise(async function(resolve, reject) {
            log('customResizer');
            log(resizeInfo);
            window.uploadedBlob = resizeInfo.blob;
            var canvas = resizeInfo.sourceCanvas;
            
            log("Uploaded image", canvas.width, canvas.height, canvas);
            trackEvent('uploadedImage');
            trackEvent('add_to_cart');
            self.saveEvent('uploadedImage', {
            });
           
            document.getElementById('million-bit-billboard').classList.add('tooltip-place');
            
            let { canvasWidth, canvasHeight } = resizeImageMax(canvas);
           
            await setImageSize(self, canvasWidth, canvasHeight, 0, 0);

            // Check if we have a spot we would like to place this
            // console.log(`Checking if we have a spot we would like to place this image on`, self.uploadToXY);
            if (self.uploadToXY && self.uploadToXY.x && self.uploadToXY.y) {
              // console.log(`Placing image on spot`, self.uploadToXY);
              self.moveImage(self.uploadToXY.x, self.uploadToXY.y, true);
              self.uploadToXY = null;
              self.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
            }

            // target elements with the "draggable" class
            window.interactable = interact('#uploadedImg')
             .resizable({
                origin: 'parent',
                edges: {
                  top   : false,
                  left  : false,
                  bottom: true,
                  right : true
                },
                modifiers: [
                  // https://interactjs.io/docs/snapping/#snapsize
                  interact.modifiers.snapSize({
                    targets: [
                      interact.snappers.grid({ width: 16, height: 16 }),
                    ],
                  }),
                  // https://interactjs.io/docs/snapping/#snap
                  // interact.modifiers.snap({
                  //   targets: [
                  //     interact.createSnapGrid({ x: 16, y: 16 })
                  //   ],
                  //   relativePoints: [ { x: 0, y: 0 } ]
                  // }),
                  interact.modifiers.restrictSize({
                    min: { width: 16, height: 16 },
                    max: { width: MAX_IMAGE_SIZE, height: MAX_IMAGE_SIZE }
                  })
                ],
              })
              .on('resizemove', async (event) => {
                log('resizemove', event.rect.width, event.rect.height, event);
                await setImageSize(self, event.rect.width, event.rect.height);
              })
              .draggable({
                origin: 'parent',
                inertia: false, // disable inertial throwing
                // keep the element within the area of it's parent
                // edges: { top: true, left: true },
                modifiers: [
                  interact.modifiers.snap({
                    targets: [
                      interact.createSnapGrid({ x: 16, y: 16 })
                    ],
                    relativePoints: [ { x: 0, y: 0 } ]
                  }),
                  interact.modifiers.restrict({
                    restriction: "parent",
                    endOnly: false,
                    elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
                  }),
                ],
                autoScroll: true,
                // call this function on every dragmove event
                onmove: dragMoveListener,
                // call this function on every dragend event
                onend: function (event) {
                  var parentPos = document.getElementById('million-bit-billboard').getBoundingClientRect();
                  var childrenPos = document.getElementById('uploadedImg').getBoundingClientRect()
                  
                  setImageOffset(Math.floor(childrenPos.left - parentPos.left), Math.floor(childrenPos.top - parentPos.top));
                  self.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
                }
              });
              
            function dragMoveListener (event) {
              // document.getElementById('million-bit-billboard').classList.remove('tooltip-place');
              var target = event.target,
                  // keep the dragged position in the data-x/data-y attributes
                  x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
                  y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
          
              target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
              target.setAttribute('data-x', x);
              target.setAttribute('data-y', y);
            }

            window.interactable.reflow({ name: 'drag', axis: 'xy' });
            
            self.loader.hide();
            self.canBuy = true;
            self.revealPlacedImage();
            
            resolve();
          });
        },
      },
      autoUpload: false,
      debug: DO_LOG,
      validation: {
        allowedExtensions: ["jpeg", "jpg", "png"],
        acceptFiles: "image/jpeg, image/png",
        stopOnFirstInvalidFile: true,
        sizeLimit: 50000 * 1000
      }
  });
}

const multiplyEth = (eth, multiplier) => {
  const multipliedWeiValue = ethers.parseUnits(eth) * BigInt(multiplier);
  return ethers.formatEther(multipliedWeiValue);
}
export default {
  name: 'app',
  // Wallet connection and the mint flow live in src/wallet/.
  mixins: [walletMixin, mintMixin],
  computed: {
    isGame() {
      return this.$route.path === '/break' || this.$route.path === '/drop';
    },
    xPostSuccess() {
      let tweetText = 'I just got my spot on the Million Bit Homepage! Go check it out and get yours @BitHomepage';
      let tweetUrl = this.shareUrl;
      if (this.$route.path == '/dob') {
        tweetText = 'I just got my spot on the DOB Pixel Gallery! Go check it out and get yours @doodle_on_base';
        tweetUrl = 'https://www.dob-nft.io/dob-millionpixelpage/';
      } else if (this.$route.path == '/zora') {
        tweetText = 'I just got my spot on the Million @zora Post! Go check it out and get yours @BitHomepage';
        tweetUrl = 'https://millionbithomepage.com/zora';
      }
      return `https://x.com/intent/post?text=${encodeURIComponent(tweetText)}&url=${encodeURIComponent(tweetUrl)}`;
    },
    xPostInvite() {
      return `https://x.com/intent/post?text=${encodeURIComponent('Get your spot on the Million Bit Homepage to be a part of onchain history! @BitHomepage')}&url=${encodeURIComponent(this.shareUrl)}`;
    },
    queryRefCode() {
      let ref = '';
      if (window.location && window.location.search) {
        const urlParams = new URLSearchParams(window.location.search);
        ref = urlParams.get('ref');
      }
      return localStorage.getItem(LOCAL_STORAGE_KEY_REFERRAL) || ref || '';
    },
    deepLinkMetamask() {
      const refCode = this.queryRefCode;
      const host = window.location.host;
      return `https://metamask.app.link/dapp/${host}/${refCode ? `?ref=${refCode}` : ''}`;
    },
    deepLinkCoinbase() {
      const refCode = this.queryRefCode;
      const host = window.location.host;
      return `https://go.cb-w.com/dapp?cb_url=${encodeURIComponent(`https://${host}/${refCode ? `?ref=${refCode}` : ''}`)}`;
    },
    shareUrl() {
      // URL with refCode if available
      let url = 'https://millionbithomepage.com/';
      if (this.refCode) {
        url += `?ref=${this.refCode}`;
      }
      return url;
    },
    ethAmtFormatted() {
      return parseFloat(this.ethAmt).toFixed(3);
    },
  },
  data () {
    return {
      demoMode: DEMO_MODE,
      test_msg: '',
      logoMoji: '💠',
      title: 'Million Bit Homepage',
      tagline: 'Own a bit of onchain history!',
      variant: 'primary',
      variantNavButton: 'outline-light',
      isMobileOrTouch: false,
      touchTimer: null,
      alertMsg: '',
      alertSwapOpts: {},
      canBuy: false,
      buyLoading: false,
      canSend: false,
      ethPerPixel: ETH_PIXEL_PRICE,
      ethAmt: "0.000",
      tokenAmt: "0.000",
      tokenPerPixel: TOKEN_PIXEL_PRICE,
      ethTokenToggle: true, // TRUE is ETH
      canToggleEthToken: false, // Can toggle between ETH and token?
      canMint: true, // Enable for NFT minting
      formInputUrl: DEMO_ADDRESS ? 'https://x.com/BitHomepage' : '',
      toggleHomepageList: true,
      requireEthBalance: true,
      isSmartWallet: false,
      trxHashSuccess: '',
      watchedDemo: false,
      email: 'mailto:millionbithomepage@gmail.com',
      telegram: 'https://t.me/+_gBV-0hdCmQzYzgx',
      discord: 'https://discord.gg/WGJwK5jkrU',
      twitter: 'https://x.com/BitHomepage',
      tiktok: 'https://www.tiktok.com/@bithomepage',
      youtube: 'https://www.youtube.com/channel/UCQtsrxAC_JT91CtGtCIxmrg',
      warpcast: 'https://warpcast.com/wopr',
      drakula: 'https://drakula.app/user/million?invite=NfmzCk',
      zora: 'https://zora.co/@millionbit',
      refCode: '',
      whiteLabel: false,
      contractAddress: config.TOKEN_CA,
      nftAddress: config.NFT_CA,
      symbol: 'BITPIX',
      swapLink: 'https://millionbithomepage.com/', // TODO
      isConnecting: false,
      provider: null,
      connectAccountAddress: '',
      connectAccountAddressTrunc: '',
      providers: [],
      tokenBalance: '',
      connectAccountChainId: '',
      connectAccountEnsName: '',
      connectAccountEnsNameTrunc: '',
      connectAccountEnsAvatar: '',
      connectAccountEnsWebsite: '',
      // Promo until April 1st
      showPromo: false,
      promoMsg: '',
      rewardsMsg: '', // '$6.6K Earned',
      isZora: false,
      pfpVidSrc: '', // set after page load so it doesn't compete with the billboard
    }
  },
  provide() {
    return {
      updateAppRoute: this.updateAppRoute,
      postToLambda: this.postToLambda,
      saveEvent: this.saveEvent,
      getProviderSigner: this.getProviderSigner,
      doUpload: this.doUpload,
      handleWalletError: this.handleWalletError,
      showAlert: this.showAlert,
      getGasLimitFromEstimate: this.getGasLimitFromEstimate,
      connectWallet: this.connectWallet,
      appData: () => { return {
        isMobileOrTouch: this.isMobileOrTouch,
        canBuy: this.canBuy,
        
        twitter: this.twitter,
        discord: this.discord,
        telegram: this.telegram,
        email: this.email,
        tiktok: this.tiktok,
        youtube: this.youtube,
        warpcast: this.warpcast,
        drakula: this.drakula,
        zora: this.zora,

        connectedAccount: {
          address: this.connectAccountAddress,
          addressTrunc: this.connectAccountAddressTrunc,
          name: this.connectAccountEnsName,
          avatar: this.connectAccountEnsAvatar,
          website: this.connectAccountEnsWebsite,
        }
      }
      },
    }
  },
  methods: {
    showDemoVideo() {
      utils.trackEvent('showDemoVideo');
      this.saveEvent('showDemoVideo', {
      });
      localStorage.setItem(LOCAL_STORAGE_KEY_DEMO_VID, 'true');
      this.watchedDemo = true;
      this.$router.push('demo');
    },
    updateAppRoute: async function(newValue, oldValue) {
      log('updateAppRoute', newValue, oldValue)
      this.toggleHomepageList = false;
      if (newValue === '/') {
        this.resetBuy();
      }

      // TODO cleanup with map
      if (newValue === '/tang') {
        this.contractAddress = config.TANG_CA;
        this.nftAddress = config.NFT_TANG_CA;
        this.symbol = 'TANG'; // TODO fetch from contract
        this.tokenPerPixel = 1; // TODO fetch from contract
        await this.updatePixelPrice();
        await this.updateTokenPixelPrice();
        await this.checkCanPayWithToken();
        this.ethTokenToggle = false;
        this.canToggleEthToken = false;
        this.showPromo = false;

        this.resetBuy();
      } else if (newValue === '/dob') {
        this.whiteLabel = true;
        this.contractAddress = config.SUBPAGES.DOB.TOKEN_CA;
        this.nftAddress = config.SUBPAGES.DOB.NFT_CA;
        this.symbol = 'DOB'; // TODO fetch from contract
        this.tokenPerPixel = 1; // TODO fetch from contract
        await this.updatePixelPrice();
        await this.updateTokenPixelPrice();
        await this.checkCanPayWithToken();
        this.ethTokenToggle = false;
        this.canToggleEthToken = false;
        this.showPromo = false;

        this.resetBuy();
      } else if (newValue === '/preme') {
        this.whiteLabel = false;
        this.contractAddress = config.SUBPAGES.PREME.TOKEN_CA;
        this.nftAddress = config.SUBPAGES.PREME.NFT_CA;
        this.symbol = 'PBP'; // TODO fetch from contract
        this.tokenPerPixel = 1; // TODO fetch from contract
        await this.updatePixelPrice();
        await this.updateTokenPixelPrice();
        await this.checkCanPayWithToken();
        this.ethTokenToggle = true;
        this.canToggleEthToken = false;
        this.showPromo = false;

        this.resetBuy();
      } else if (newValue === '/zora') {
        this.whiteLabel = false;
        this.contractAddress = config.SUBPAGES.ZORA.TOKEN_CA;
        this.nftAddress = config.SUBPAGES.ZORA.NFT_CA;
        this.symbol = 'MZP'; // TODO fetch from contract
        this.tokenPerPixel = 100; // TODO fetch from contract
        await this.updatePixelPrice();
        await this.updateTokenPixelPrice();
        await this.checkCanPayWithToken();
        this.ethTokenToggle = false;
        this.canToggleEthToken = false;
        this.showPromo = false;
        this.isZora = true;

        this.resetBuy();
      } else {
        this.whiteLabel = false;
        this.contractAddress = config.TOKEN_CA;
        this.nftAddress = config.NFT_CA;
        this.symbol = 'BITPIX';
        this.tokenPerPixel = 1;
        await this.updatePixelPrice();
        await this.checkCanPayWithToken();
        this.ethTokenToggle = true;
        // this.canToggleEthToken = true;
      }
    },
    setPixelsToBuy: function(pixels) {
      this.ethAmt = multiplyEth(this.ethPerPixel.toString(), pixels).toString();
      this.tokenAmt = multiplyEth(this.tokenPerPixel.toString(), pixels).toString();
    },
    validateImageLocation: function(img_offset_x, img_offset_y, img_width, img_height) {
      log('validateImageLocation', img_offset_x, img_offset_y, img_width, img_height)

      // Verify that the img_offset_x and img_offset_y are on the 16 x 16 grid
      if (img_offset_x % 16 !== 0 || img_offset_y % 16 !== 0) {
        // Calculate the difference between the current position and the nearest 16 x 16 grid
        const dx = img_offset_x - (Math.floor(img_offset_x / 16) * 16);
        const dy = img_offset_y - (Math.floor(img_offset_y / 16) * 16);

        // Snap the image to the nearest 16 x 16 grid
        const image = document.getElementById('uploadedImg');
        const x = (img_offset_x || 0) - dx;
        const y = (img_offset_y || 0) - dy;

        // Apply the transformation
        image.style.transform = `translate(${x}px, ${y}px)`;

        // Update the position attributes
        image.setAttribute('data-x', x);
        image.setAttribute('data-y', y);
        img_offset_x = Math.floor(img_offset_x / 16) * 16;
        img_offset_y = Math.floor(img_offset_y / 16) * 16;
      }

      const p = getPriceForPosition(img_offset_x, img_offset_y, img_width, img_height, true);
      if (p) {
        this.setPixelsToBuy(p);
        document.getElementById('million-bit-billboard').classList.remove('tooltip-place');
        this.canSend = true;
        return true;
      } else {
        // Cannot buy this location
        document.getElementById('million-bit-billboard').classList.add('tooltip-place');
        this.canSend = false;
        return false;
      }
    },
    navigateTo: function(route) {
      this.$bvModal.hide('modal-intro');
      if (route === '/') {
        this.toggleHomepageList = true;
      } else {
        this.toggleHomepageList = false;
      }
      this.$router.push(route);
    },
    doToggleEthToken: function(isEth) {
      if (!isEth) {
        this.ethTokenToggle = false;
      } else {
        this.ethTokenToggle = true;
      }
    },
    doUpload: function (x, y) {
      if (this.canBuy) {
        this.cancelBuy();
        return;
      }
      this.uploadToXY = { x, y };
      trackEvent('doUpload:file');
      document.querySelector('input[name="qqfile"]').click()
    },
    doUploadAvatar: async function(event) {
      trackEvent('doUpload:avatar');
      const img = await fetchImage(this.connectAccountEnsAvatar);
      window.manualUploader.addFiles(img);
    },
    handleError: function(error) {
      console.error(error);
      this.showAlert('An error occurred. Please try again.');
    },
    doCopyToClipboard: function(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.showAlert('Copied to clipboard!');
      }).catch(err => {
        console.error('Failed to copy text: ', err);
      });
      // var dummy = document.createElement("textarea");
      // document.body.appendChild(dummy);
      // dummy.value = text;
      // dummy.select();
      // document.execCommand("copy");
      // document.body.removeChild(dummy);
    },
    cancelBuy: function (event) {
      this.resetBuy();
    },
    resetBuy: function() {
      this.buyLoading = false;
      this.canBuy = false;
      initUploader(this);
    },
    getEventUserEnv: function() {
      let userEnv = {
        ensName: this.connectAccountEnsName,
        address: this.connectAccountAddress,
        chainId: this.connectAccountChainId,
        agent: navigator.userAgent,
        isMobileOrTouch: this.isMobileOrTouch,
        provider: {
          isCoinbaseWallet: this.provider ? this.provider.isCoinbaseWallet : null,
          isCoinbaseBrowser: this.provider ? this.provider.isCoinbaseBrowser : null,
          isMetaMask: this.provider ? this.provider.isMetaMask : null,
          isRabby: this.provider ? this.provider.isRabby : null,
          isSmartWallet: this.isSmartWallet,
        }
      };
      return userEnv;
    },
    saveEvent: function(eventType, eventData) {
      const userEnv = this.getEventUserEnv();
      this.postToLambda('saveEvent', {
        ...userEnv,
        eventType,
        eventData,
      });
    },
    getRefCode: async function() {
      if (!this.refCode && this.connectAccountAddress) {
        const userEnv = this.getEventUserEnv();
        const response = await this.postToLambda('getRefCode', {
          ...userEnv,
        });
        if (response && response.code) {
          this.refCode = response.code;
        }
      }
      return this.refCode;
    },
    showAlert: function(msg, swapOpts) {
      this.alertMsg = msg;
      this.alertSwapOpts = swapOpts;
      this.$bvModal.show('modal-alert');
    },
    blurInput() {
      this.$refs.formInputValueUrl.blur()
    },
    initPushNotification() {
      if (!('serviceWorker' in navigator)) {
        // alert('No Service Worker support!')
        return;
      }
      // if (!('PushManager' in window)) {
      //   alert('No Push API Support!')
      //   return;
      // }

      // if ('serviceWorker' in navigator && 'PushManager' in window) {
      console.log('Service Worker and Push are supported');

      // Notification.requestPermission().then(async () => {
      navigator.serviceWorker.register('sw.js').then((swReg) => {
        // alert('Service Worker is registered', swReg);
        this.swRegistration = swReg;
        this.initSubscription();
      }).catch((error) => {
        // alert('Service Worker Error', error);
        // alert(JSON.stringify(error));
      });
      // });
    // } else {
    //   console.warn('Push messaging is not supported');
    //   pushButton.textContent = 'Push Not Supported';
    // }
    },
    initSubscription() {
      // Set the initial subscription value
      this.swRegistration.pushManager.getSubscription().then((subscription) => {
        this.isSubscribed = !(subscription === null);
        this.updateSubscriptionOnServer(subscription);

        if (this.isSubscribed) {
          console.log('User IS subscribed.', subscription);
        } else {
          console.log('User is NOT subscribed.');
          this.subscribeUser();
        }
      })
      .catch((error) => {
        // alert('Error during getSubscription()', error);
      });
    },
    postToLambda: async function(name, data) {
      log('Posting data to lambda', name, data);
      try {
          const response = await fetch(PUSH_SUB_URL+name, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
          })
          if (response.ok) {
            return response.json();
          }
          // .then(response => {
          //   if (!response.ok) {
          //     console.error('Network response was not ok ' + response.statusText);
          //   }
          //   trackEvent('pushSubscribed');
          //   return response.json(); // Assuming the response is JSON
          // })
          // .then(data => {
          //   console.log('Data received:', data);
          // })
          // .catch(error => {
          //   console.error('Fetch error:', error);
          // });
          // utils.toast({
          //   title: `Million Bit Homepage`,
          //   message: `Notifications enabled`,
          //   type: "success",
          //   duration: 5000
          // });
        } catch (e) {
          console.error('Fetch error:', e);
          return undefined;
        }
    },
    updateSubscriptionOnServer(subscription) {
      localStorage.setItem(LOCAL_STORAGE_NOTIFICATION_SUB_ENDPOINT, JSON.stringify(subscription.endpoint));
      if (subscription) {
        console.log('updateSubscriptionOnServer', subscription);
        try {
          fetch(PUSH_SUB_URL+'subscribe', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(subscription),
          })
          .then(response => {
            if (!response.ok) {
              console.error('Network response was not ok ' + response.statusText);
            }
            trackEvent('pushSubscribed');
            return response.json(); // Assuming the response is JSON
          })
          .then(data => {
            console.log('Data received:', data);
          })
          .catch(error => {
            console.error('Fetch error:', error);
          });
          utils.toast({
            title: `Million Bit Homepage`,
            message: `Notifications enabled`,
            type: "success",
            duration: 5000
          });
        } catch (e) {
          console.error('Fetch error:', e);
        }
      }
      // TODO: Send subscription to application server

      // const subscriptionJson = document.querySelector('.js-subscription-json');
      // const subscriptionDetails =
      //   document.querySelector('.js-subscription-details');

      // if (subscription) {
      //   subscriptionJson.textContent = JSON.stringify(subscription);
      //   subscriptionDetails.classList.remove('is-invisible');
      // } else {
      //   subscriptionDetails.classList.add('is-invisible');
      // }
    },
    subscribeUser() {
      const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
      this.swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
      })
      .then((subscription) => {
        console.log('User is subscribed', subscription);

        this.updateSubscriptionOnServer(subscription);

        this.isSubscribed = true;

        // updateBtn();
      })
      .catch((err) => {
        console.log('Failed to subscribe the user: ', err);
        // updateBtn();
      });
    },
    showInviteFriends: async function() {
      await this.getRefCode();
      this.$bvModal.show('modal-invite-friends');
    },
    moveImage(dx, dy, toAbsolute) {
      const image = document.getElementById('uploadedImg');
      let imageX = parseFloat(image.getAttribute('data-x')) || 0;
      let imageY = parseFloat(image.getAttribute('data-y')) || 0;
      if (toAbsolute) {
        dx = dx - imageX;
        dy = dy - imageY;
      }
      let x = imageX + dx;
      let y = imageY + dy;

      // Apply the transformation
      image.style.transform = `translate(${x}px, ${y}px)`;

      // Update the position attributes
      image.setAttribute('data-x', x);
      image.setAttribute('data-y', y);

      // window.img_offset_x = x;
      // window.img_offset_y = y;
      setImageOffset(x, y);
    },
    // On narrow screens the billboard is a scroll box: keep the image being
    // placed in view.
    revealPlacedImage() {
      if ((document.documentElement.clientWidth || window.innerWidth) >= 1056) return;
      this.$nextTick(() => {
        const image = document.getElementById('uploadedImg');
        if (image && image.scrollIntoView) {
          image.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
    },
    moveSpot(direction) {
      if (direction === 'left') {
        this.moveImage(-16, 0);
      } else if (direction === 'right') {
        this.moveImage(16, 0);
      } else if (direction === 'up') {
        this.moveImage(0, -16);
      } else if (direction === 'down') {
        this.moveImage(0, 16);
      }
      this.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
      window.interactable.reflow({ name: 'drag', axis: 'xy' });
      this.revealPlacedImage();
    },
    async resizeSpot(direction) {
      const scaleImage = async (increment) => {
        const image = document.getElementById('uploadedImg');
        const currentWidth = image.offsetWidth;
        const currentHeight = image.offsetHeight;

        if ((direction === 'bigger' && (currentHeight >= MAX_IMAGE_SIZE || currentWidth >= MAX_IMAGE_SIZE))
          || (direction === 'smaller' && (currentHeight <= 16 || currentWidth <= 16))
        ) {
          return;
        }

        // Calculate the new dimensions
        const newWidth = currentWidth + increment;
        const newHeight = currentHeight + increment;

        // Ensure the image doesn't scale down below a minimum size (e.g., 16x16 pixels)
        if (newWidth >= 16 && newHeight >= 16) {
          await setImageSize(this, newWidth, newHeight);
        }
      }
      if (direction === 'bigger') {
        scaleImage(16);
      } else if (direction === 'smaller') {
        scaleImage(-16);
      }
      window.interactable.reflow({ name: 'drag', axis: 'xy' });
    },
    btnPress(direction) {
      // Your button press logic here
      this.moveSpot(direction);
    },
    handleTouchStart(event, direction) {
      event.preventDefault(); // Prevents text selection and default touch behavior
      // Call btnPress immediately
      this.btnPress(direction);
      this.touchTimer = setTimeout(() => {
        // Start repeating every 500ms
        this.repeatTimer = setInterval(() => {
          this.btnPress(direction);
        }, 100);
      }, 500); // Adjust this timeout for long press sensitivity
    },
    handleTouchEnd(event) {
      event.preventDefault(); // Prevents zooming
      this.handleTouchCancel();
    },
    handleTouchCancel() {
      clearTimeout(this.touchTimer);
      clearInterval(this.repeatTimer);
    },
  },
  watch: {
    // Watch the $route object for changes
    $route(to, from) {
      log('Route changed from', from.path, 'to', to.path);
      // Umami tracks client-side route changes automatically
    },
  },
  created: function () {
    log('---------CREATED--------');
    axios.get(utils.getTsPath('config.json')).then((response) => {
      console.log(`---------- CONFIG ---------`)
      console.log(response, response.data);
      const config = response.data;

      if (config.hasOwnProperty('ethPerPixel')) {
        this.ethPerPixel = config.ethPerPixel;
        console.log(`Pixel price: ${config.ethPerPixel}`);
      }

      if (config.hasOwnProperty('promo')) {
        if (config.promo) {
          this.showPromo = config.promo;
          if (config.promo.msg) {
            this.promoMsg = config.promo.msg;
          }
        } else {
          this.showPromo = false;
        }
      }

    });
  },
  mounted() {
    log('---------MOUNTED--------');
    // this.toggleHomepageList = true;
    // initUploader(this); // triggered when child view loads
    this.providers = [];
    setTimeout(()=> {
      this.loadProviders();
    }, 5500); // TODO this sucks, but extending helps fighting wallets

    if (!localStorage.getItem(DID_PROMPT_NOTIFICATIONS)) {
      localStorage.setItem(DID_PROMPT_NOTIFICATIONS, true);
      this.initPushNotification();
    }

    this.watchedDemo = localStorage.getItem(LOCAL_STORAGE_KEY_DEMO_VID);
    if (!this.watchedDemo) {
      const loadPfpVid = () => setTimeout(() => { this.pfpVidSrc = '/static/pfp-talking-head.webm'; }, 1000);
      if (document.readyState === 'complete') {
        loadPfpVid();
      } else {
        window.addEventListener('load', loadPfpVid, { once: true });
      }
    }

    this.isMobileOrTouch = utils.isMobileOrTouch();

    // Check for referral code
    if (window.location && window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);
      const ref = urlParams.get('ref');
      if (ref) {
        // this.referralCode = ref;
        localStorage.setItem(LOCAL_STORAGE_KEY_REFERRAL, ref);
        this.saveEvent('referral', ref);
      }
    }

    window.addEventListener("eip6963:announceProvider",
      (event) => {
        log('eip6963:announceProvider', event.detail);
        trackEvent('hasWallet:'+event.detail.info.rdns);
        if (event.detail && ['app.phantom'].includes(event.detail.info.rdns)) {
          this.pushProvider(event.detail.provider);
        }
      }
    );
    // setTimeout(()=> {
    //   window.dispatchEvent(new Event("eip6963:requestProvider"));
    // }, 1500);
  }
}
</script>

<style>
.bg-primary {
  background-color: #0063cd !important;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #bebebe;
  margin-top: 0px;
}
#million-bit-billboard {
  position: relative;
}
#million-bit-billboard.tooltip-place::after {
    content: "⬇️ Place your image on an empty spot on the canvas";
    text-align: left;
    display: block;
    height: 40px;
    width: 1024px;
    position: absolute;
    left: 0px;
    background: #ffffe5;
    top: -45px;
    font-weight: bold;
    padding: 8px;
    border: 1px solid black;
    border-radius: 5px;
}
.mbh-title {
  font-size: 60px;
  color: #fff; /* for mobile that doesn't support color fonts */
  cursor: pointer;
  line-height: 1em;
}
.subtitle {
  font-size: 0.8em;
  color: #e8e8e8;
}
.header-l, .header-r {
  min-width: 280px;
}
.btn.btn-outline-light {
 background-color: #00000021;
 /* text-transform: uppercase; */
 border-color: #f8f9fa59;
}
.btn.btn-outline-lighter {
 background-color: #0000;
 /* text-transform: uppercase; */
 border-color: #f8f9fa59;
}
.btn-outline-light:hover {
  background-color: #f8f9fa;
}
.nav-buttons .btn {
  min-width: 120px;
}

.btn-warning {
  min-width: 160px;
  font-weight: bold;
  border-radius: 5px !important;
}

#uploadedImg,
#uploadedImg * {
  -ms-touch-action: none;
  touch-action: none;
}
#uploadedImg {
  background: white;
}
#countdown {
  font-size: 1em;
  color: #393939;
  width: 420px;
  margin: 50px auto;
}
#countdown ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  background: #1a1a1a;
  border-radius: 4px;
}
#countdown li {
  display: inline-block;
  font-size: 1.0em;
  list-style-type: none;
  padding: 1em;
  text-transform: uppercase;
  
  border: 1px solid #0000001a;
  width: 108px;
  color: #707070;
}

#countdown li span {
  display: block;
  font-size: 2.5rem;
  color: white;
  font-family: 'Honk'
}
.connect-menu, .nav-menu {
  /* height: 120px; */
}
#modal-connect img {
  max-height: 2em;
  margin-right: 4px;
}
#modal-connect .btn {
  text-align: left;
}
.connect-menu button.btn.btn-connect, #create-wallet {
  min-width: 200px;
  border-color: #f8f9fa59;
}
.connect-menu a {
  border-color: #f8f9fa59;
}
/* Text contrast (WCAG AA): white on bootstrap's #007bff is 3.97:1. */
.btn.btn-connect {
  background-color: #0069d9;
}
.btn.btn-connect:hover {
  background-color: #005cbf;
}
.mbh-footer .navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.65);
}
.connect-menu img {
  max-height: 22px;
}
.disconnect svg {
  max-height: 20px;
}
.loader {
  position: absolute;
  width: 22px; /* control the size */
  aspect-ratio: 1;
  display: grid;
  -webkit-mask: conic-gradient(from 22deg, #0003,#000);
          mask: conic-gradient(from 22deg, #0003,#000);
  animation: load 1s steps(8) infinite;
}
.loader,
.loader:before {
  --_g: linear-gradient(#616161 0 0) 50%; /* update the color here */
  background: 
    var(--_g)/34% 8%  space no-repeat,
    var(--_g)/8%  34% no-repeat space;
}
.loader:before {
  content: "";
  transform: rotate(45deg);
}
@keyframes load {
  from {transform: rotate(0turn)}
  to   {transform: rotate(1turn)}
}

.text-bold {
  font-weight: bold;
}

@keyframes confetti-slow {
  0% {
    transform: translate3d(0, 0, 0) rotateX(0) rotateY(0);
  }
  100% {
    transform: translate3d(25px, 105vh, 0) rotateX(360deg) rotateY(180deg);
  }
}
@keyframes confetti-medium {
  0% {
    transform: translate3d(0, 0, 0) rotateX(0) rotateY(0);
  }
  100% {
    transform: translate3d(100px, 105vh, 0) rotateX(100deg) rotateY(360deg);
  }
}
@keyframes confetti-fast {
  0% {
    transform: translate3d(0, 0, 0) rotateX(0) rotateY(0);
  }
  100% {
    transform: translate3d(-50px, 105vh, 0) rotateX(10deg) rotateY(250deg);
  }
}
.confetti-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  z-index: 99999;
}
.c-container {
  width: 100vw;
  height: 100vh;
}

.confetti-container {
  perspective: 700px;
  position: absolute;
  overflow: hidden;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.confetti {
  position: absolute;
  z-index: 1;
  top: -10px;
  border-radius: 0%;
}
.confetti--animation-slow {
  animation: confetti-slow 2.25s linear 1 forwards;
}
.confetti--animation-medium {
  animation: confetti-medium 1.75s linear 1 forwards;
}
.confetti--animation-fast {
  animation: confetti-fast 1.25s linear 1 forwards;
}


/* ======= Toast message ======== */

#toast {
  position: fixed;
  bottom: 32px;
  right: 32px;
  z-index: 999999;
  box-sizing: border-box;
}

.toaster {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 2px;
  padding: 20px 0;
  min-width: 400px;
  max-width: 450px;
  border-left: 4px solid;
  box-shadow: 0 5px 8px rgba(0, 0, 0, 0.08);
  transition: all linear 0.3s;
  box-sizing: border-box;
  text-align: left;
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(calc(100% + 32px));
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeOut {
  to {
    opacity: 0;
  }
}

.toast-success {
  border-color: #0063cd;
}

.toast-success .toast_icon {
  color: #47d864;
}

.toast-info {
  border-color: #2f86eb;
}

.toast-info .toast_icon {
  color: #2f86eb;
}

.toast-warning {
  border-color: #ffc021;
}

.toast-warning .toast_icon {
  color: #ffc021;
}

.toast-error {
  border-color: #ff623d;
}

.toast-error .toast_icon {
  color: #ff623d;
}

.toast + .toast {
  margin-top: 24px;
}

.toast_icon {
  font-size: 24px;
}

.toast_icon,
.toast_close {
  padding: 0 16px;
}

.toast_body {
  flex-grow: 1;
}

.toast_title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.toast_msg {
  font-size: 14px;
  color: #888;
  margin-top: 6px;
  line-height: 1.5;
}

.toast_close {
  font-size: 20px;
  color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.btn-icon {
  min-width: 50px !important;
}

.ensAvatar {
  max-height: 22px;
}

.header-m .form-inline {
  justify-content: space-between;
}

#pfp-vid-container {
  cursor: pointer;
  position: fixed;
  bottom: 26px;
  right: 26px;
  height: 78px;
  width: 78px;
}
#pfp-vid {
  background: #000 url(/static/pfp-talking-head.jpg) center top / 100% auto no-repeat; /* until the video loads */
  width: 100%;             /* Adjust width as needed */
  height: 100%;          /* Show only the top third */
  overflow: hidden;        /* Hide the rest of the video */
  position: relative;
  border-radius: 50%;
  box-shadow: 0px 0px 18px white;
  border: 2px solid #afafaf;
}
#pfp-vid div {
}
#pfp-vid video {
  width: 100%;
  height: auto;            /* Keep aspect ratio */
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
}

/* .mbh-footer {
  font-size: 1.2em;
} */

/* Below desktop width the header stacks: buttons and wallet on one row,
   the title under them. */
@media (max-width: 1023px) {
  #app > .navbar {
    padding: 8px 12px;
    flex-wrap: wrap !important; /* navbar-expand-lg sets nowrap from 992px */
  }
  #app > .navbar .mr-0 {
    width: 100%;
  }
  .header-l, .header-r {
    min-width: 0;
    flex-shrink: 0;
    margin-top: 4px;
    margin-bottom: 8px;
  }
  .header-l {
    order: 0;
  }
  .header-r {
    order: 1;
  }
  .header-m {
    order: 2;
  }
}

/* Phones */
@media (max-width: 767px) {
  #pfp-vid-container {
    bottom: 16px;
    right: 16px;
    height: 56px;
    width: 56px;
  }
  .mbh-title {
    font-size: 34px;
  }
  .nav-buttons .btn {
    min-width: 0;
  }
  .connect-menu button.btn.btn-connect {
    min-width: 0;
  }
  .nav-buttons .btn.btn-icon {
    min-width: 44px !important;
  }
  .nav-buttons .btn, .connect-menu .btn, .header-m .btn {
    min-height: 44px;
  }
  .btn-warning {
    min-width: 0;
  }
  input#link-url {
    width: 100%;
    margin-bottom: 12px;
    order: -1;
  }
  .modal-dialog {
    max-width: 94%;
    margin: 12px auto;
  }
  .modal-header .close {
    padding: 12px 16px;
    margin: -12px -16px -12px auto;
  }
  #countdown {
    width: 90%;
  }
  .mbh-footer .navbar {
    flex-wrap: wrap;
    justify-content: center;
  }
  .mbh-footer .navbar-nav {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
  .mbh-footer .nav-link {
    padding: 10px 12px;
  }
  #copyright {
    white-space: normal;
    font-size: 12px;
  }
  #toast {
    top: auto;
    bottom: 84px;
    right: 8px;
    left: 8px;
  }
  .toaster {
    min-width: 0;
    max-width: none;
  }
}

/* Game pages keep the old phone rendering (a 1024px page scaled down), so
   the floating avatar and toasts are enlarged there as they used to be. */
@media screen and (max-device-width: 768px) {
  html.game-viewport #toast {
    scale: 2;
  }
  html.game-viewport #pfp-vid-container {
    height: 132px;
    width: 132px;
  }
}

/* The billboard is in a scroll box below this width; show the placement hint
   in the mobile controls instead of above the billboard. */
@media (max-width: 1055px) {
  #million-bit-billboard.tooltip-place::after {
    display: none;
  }
}

#mobile-controls {
  position: fixed;
  bottom: 0;
  height: 160px;
  left: 0;
  right: 0;
  background: #0063cd;
  z-index: 999999;

  /* Prevent default selection */
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
#mobile-controls > div {
  border: 2px solid white;
  border-radius: 8px;
  background: #ffffff52;
  color: #fff;
  width: 52px;
  height: 52px;
  padding: 12px;
}

#mobile-controls > div > svg {
  height: 100%;
  width: 100%;
}
#control-left {
  position: absolute;
  top: 54px;
  left: calc(50vw - 26px - 60px);
}
#control-right {
  position: absolute;
  top: 54px;
  left: calc(50vw + 34px);
}
#control-up {
  position: absolute;
  top: 0;
  left: calc(50vw - 26px);
}
#control-down {
  position: absolute;
  top: 108px;
  left: calc(50vw - 26px);
}
#control-bigger {
  position: absolute;
  top: 54px;
  right: 16px;
}
#control-smaller {
  position: absolute;
  top: 54px;
  left: 16px;
}
#mobile-controls > p.mc-hint {
  position: absolute;
  top: -36px;
  left: 0;
  right: 0;
  margin: 0;
  padding: 6px 8px;
  background: #ffffe5;
  border-top: 1px solid #000;
  font-weight: bold;
  font-size: 14px;
  color: #000;
}
#copyright {
  font-size: 1em;
}
body > canvas {
  /* Prevent stretching mobile scroll horizontal */
  max-width: 100%;
}
.send-feedback img {
  max-height: 18px;
}

.promo-header, .rewards-header {
  width: 100%;
  clear: both;
  background: #7ceafd;
  font-size: 1.2em;
  border-bottom: rgb(0, 7, 140) 1px solid;
}
.rewards-header {
  background: #004d9f !important;
  font-size: 1.2em;
  border-bottom: #00448d 1px solid;
  color: rgb(194, 194, 194);
}
</style>
